import React, { useState } from 'react';
import {
    Button,
    FormControlLabel,
    Radio,
    RadioGroup,
    Typography,
    useTheme,
} from '@mui/material';
import { DashboardT } from 'business/definitions';
import {
    FilterOption,
    ScheduledDashboardEmail,
} from 'components/DashboardSendModal/types';
import InfoModal from 'components/SharedComponents/Modals/InfoModal';
import SharingModalDefaultFilters from 'components/SharedItemUI/SharingModalDefaultFilters';
import { useTranslation } from 'react-i18next';
import TextInfo from 'ui/TextInfo/TextInfo';
import Flex from 'ui/Flex/Flex';

type Props = {
    scheduledEmail: ScheduledDashboardEmail;
    updateEmail: (updates: Partial<ScheduledDashboardEmail>) => void;
    dashboard: DashboardT;
};
const EmailFilterOptions = ({
    scheduledEmail,
    updateEmail,
    dashboard,
}: Props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [openDefaultFiltersPreview, setOpenDefaultFiltersPreview] =
        useState(false);
    const showDefaultFiltersPreview = () => setOpenDefaultFiltersPreview(true);
    return (
        <Flex direction="column" gap={theme.spacing(1)}>
            <Typography variant="body1SemiBold">
                <TextInfo
                    tooltip={t('sendDashboard.filterOption.tooltip')}
                    sx={{
                        '& .MuiBadge-badge': {
                            right: '-1rem',
                        },
                    }}
                >
                    {t('sendDashboard.filterOption.label')}
                </TextInfo>
            </Typography>
            <RadioGroup
                id="filter-option-radio-group"
                value={
                    scheduledEmail.filterOption ??
                    FilterOption.SENDER_FILTERS_SENDER_SCOPES
                }
                onChange={(event) =>
                    updateEmail({
                        filterOption: event.target.value as FilterOption,
                    })
                }
            >
                {Object.values(FilterOption).map((option) => (
                    <FormControlLabel
                        key={option}
                        value={option}
                        control={<Radio />}
                        label={t(`sendDashboard.filterOption.${option}`)}
                    />
                ))}
            </RadioGroup>
            <Button
                onClick={showDefaultFiltersPreview}
                sx={{ width: 'fit-content' }}
            >
                {t('sendDashboard.defaultFiltersPreview')}
            </Button>
            {openDefaultFiltersPreview && (
                <InfoModal
                    isOpen={openDefaultFiltersPreview}
                    onClose={() => setOpenDefaultFiltersPreview(false)}
                    title={t('sharingModal.defaultFiltersSharingTitle')}
                >
                    <SharingModalDefaultFilters
                        dashboard={dashboard}
                        isPreview
                    />
                </InfoModal>
            )}
        </Flex>
    );
};

export default EmailFilterOptions;
